"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("../../../shared/modules/UIUtils");
var BaseController_1 = require("../../../shared/controllers/BaseController");
var webAApi_1 = require("../../api/webAApi");
var ListBonusTemplatesAvailForDepositTypeCtl = /** @class */ (function (_super) {
    __extends(ListBonusTemplatesAvailForDepositTypeCtl, _super);
    function ListBonusTemplatesAvailForDepositTypeCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_value = UIUtils_1.UIUtils.IProp2Str(function (o) { o.value; });
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this._errDialog = errDialog;
        return _this;
    }
    ListBonusTemplatesAvailForDepositTypeCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
        };
    };
    ListBonusTemplatesAvailForDepositTypeCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    ListBonusTemplatesAvailForDepositTypeCtl.prototype.LoadData = function (brandId, currencyId, isDeposit, isNoDep, onDone) {
        var _this = this;
        webAApi_1.ListAllowedBonusTemplatesByAppCurrencyIdGet.exec({
            brand_id: brandId,
            kind_deposit: isDeposit,
            kind_nodeposit: isNoDep
        }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    value: resp.list[i].title,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return ListBonusTemplatesAvailForDepositTypeCtl;
}(BaseController_1.BaseController));
exports.ListBonusTemplatesAvailForDepositTypeCtl = ListBonusTemplatesAvailForDepositTypeCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/controllers/ListBonusTemplatesAvailForDepositTypeCtl.ts
// module id = 2092
// module chunks = 0